import { render } from "./PosterImage.vue?vue&type=template&id=1bf8b484&scoped=true"
import script from "./PosterImage.vue?vue&type=script&lang=js"
export * from "./PosterImage.vue?vue&type=script&lang=js"

import "./PosterImage.vue?vue&type=style&index=0&id=1bf8b484&scoped=true&lang=css"

import exportComponent from "/vercel/path0/shinai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf8b484"]])

export default __exports__